import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {
  useCreateFacilityMutation,
} from '../../store/builder/inspections.api';
import Input from '../Input';

import './index.scss';
import Checkbox from '../Checkbox';
import Datepicker from '../Datepicker';
import moment from 'moment';
import useLoader from '../../global/UseLoadingHandler';
import {useTranslation} from '../../hooks/useTranslation';
import {
  useIsExternalCodeRevision,
  useSignatureBaseOptions,
} from '../../hooks/useSignatureBaseOptions';
import CustomSelect from '../CustomSelect';

export default function FacilityModal({setModal, getData}) {
  const {t} = useTranslation();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [data, setData] = useState({
    name: null,
    external_code: null,
    inspections_enabled: false,
    custom_inspections_enabled: false,
    default_facility_inspections_enabled: false,
    last_weekly_date: null,
    last_monthly_date: null,
    last_annual_date: null,
    last_quarterly_date: null,
    last_semiannual_date: null,
  });

  const [create, {isError, isFetching, isSuccess, error, data: createData}] =
    useCreateFacilityMutation();
  const [errorHandler, setErrorHandler] = useErrorHandler([error]);
  const showExternalCode = useIsExternalCodeRevision();
  const [externalCodeOptions, externalCodeOptionsLoading] =
    useSignatureBaseOptions({skip: !showExternalCode});
  useLoader([isFetching]);

  const createFacility = () => {
    if (data?.name?.length > 1) {
      // Format dates to Y-m-d format and structure as fields array
      const formattedData = { ...data };
      
      // Create fields array with formatted date values
      const fieldsArray = [];
      const dateFields = ['last_weekly_date', 'last_monthly_date', 'last_quarterly_date', 'last_semiannual_date', 'last_annual_date'];
      
      dateFields.forEach(key => {
        if (formattedData[key]) {
          // Convert from MM/DD/YYYY to YYYY-MM-DD format
          const formattedValue = moment(formattedData[key], 'MM/DD/YYYY').format('YYYY-MM-DD');
          fieldsArray.push({
            key: key,
            value: formattedValue
          });
        }
      });
      
      // Remove individual date fields from the main object and add fields array
      const { last_weekly_date, last_monthly_date, last_quarterly_date, last_semiannual_date, last_annual_date, external_code, ...restData } = formattedData;
      
      const finalData = {
        ...restData,
        ...(showExternalCode ? {external_code: external_code || ''} : {}),
        fields: fieldsArray
      };
      
      create(finalData).then(res => {
        if (res?.data?.message) {
          toast.success(res?.data?.message);
          setTimeout(() => {
            getData();
          }, 1000);
        }
      }).finally(() => {
        setModal(false);
      });
    } else {
      toast.error(t('facilityModal.messages.fillNameField'), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
      });
    }
  };

  return (
    <div className='facility-modal'>
      <div className='facility-modal__content'>
        <div className='facility-modal__header'>
          <span></span>
          <div className='facility-modal__title'>{t('facilityModal.title')}</div>
          <div className='facility-modal__close'>
            <img
              onClick={() => {
                setModal(false);
                setData(null);
              }}
              src='/assets/icons/close.svg'
              alt='close'
            />
          </div>
        </div>
        <form action='' className='facility-modal__form'>
          <div className='facility-modal__field'>
            <Input
              containerWidth={'100%'}
              label={t('facilityModal.labels.facilityName')}
              placeholder={t('facilityModal.labels.facilityName')}
              id='facilityName'
              onChange={e => {
                setData(old => ({...old, name: e.target.value}));
              }}
            />
          </div>
          {showExternalCode && (
          <div className='facility-modal__field'>
            <CustomSelect
              id='external_code'
              label={t('modal.signatureBaseId')}
              placeholder={t('modal.signatureBaseId')}
              name={'external_code'}
              options={externalCodeOptions}
              value={data?.external_code}
              isLoading={externalCodeOptionsLoading}
              onChange={e => {
                setData(old => ({...old, external_code: e.target.value}));
              }}
            />
          </div>
          )}
          {/*<div className="facility-modal__field">*/}
          {/*  <Input*/}
          {/*    label="Airport ID"*/}
          {/*    placeholder="Airport ID"*/}
          {/*    id="airportId"*/}
          {/*    onChange={(e) => {*/}
          {/*      setData((old) => ({ ...old, airport_id: e.target.value }));*/}
          {/*    }}*/}
          {/*  />*/}
          {/*</div>*/}
          {userInfo?.is_global && (
            <>
              <div className='facility-modal__field'>
                <Checkbox
                    label={t('facilityModal.labels.inspectionsEnabled')}
                    id={'inspections_enabled'}
                    checked={data?.inspections_enabled}
                    onChange={e => {
                      setData(old => ({
                        ...old,
                        inspections_enabled: e.target.checked,
                      }));
                    }}
                />
              </div>
              <div className='facility-modal__field'>
                <Checkbox
                    label={t('facilityModal.labels.customInspectionsEnabled')}
                    id={'custom_inspections_enabled'}
                    checked={data?.custom_inspections_enabled}
                    onChange={e => {
                      setData(old => ({
                        ...old,
                        custom_inspections_enabled: e.target.checked,
                      }));
                    }}
                />
              </div>
            </>
          )}
          <div className='facility-modal__field'>
            {/*<Checkbox*/}
            {/*  label={"Do fuel facility checks apply to this facility?"}*/}
            {/*  id={"default_facility_inspections_enabled"}*/}
            {/*  onChange={(e) => {*/}
            {/*    setData((old) => ({*/}
            {/*      ...old,*/}
            {/*      default_facility_inspections_enabled: e.target.checked,*/}
            {/*    }));*/}
            {/*  }}*/}
            {/*/>*/}
            <span style={{fontSize: '14px'}}>
              {t('facilityModal.question.fuelFacilityChecks')}
            </span>
            <div
              className='subscription__plan-info_checkbox'
              style={{marginTop: 10, marginBottom: 16}}
            >
              <div className='radio-option'>
                <input
                  type='radio'
                  name={'no'}
                  id={'no'}
                  value={'No'}
                  checked={!data?.default_facility_inspections_enabled}
                  onChange={e => {
                    setData(old => ({
                      ...old,
                      default_facility_inspections_enabled: false,
                    }));
                  }}
                />
                <label
                  style={
                    !data?.default_facility_inspections_enabled
                      ? {color: '#4268B0'}
                      : {}
                  }
                  htmlFor={'no'}
                >
                  {t('facilityModal.options.no')}
                </label>
              </div>
              <div className='radio-option'>
                <input
                  type='radio'
                  name={'yes'}
                  id={'yes'}
                  checked={data?.default_facility_inspections_enabled}
                  value={'Yes'}
                  onChange={e => {
                    setData(old => ({
                      ...old,
                      default_facility_inspections_enabled: true,
                    }));
                  }}
                />
                <label
                  style={
                    data?.default_facility_inspections_enabled
                      ? {color: '#4268B0'}
                      : {}
                  }
                  htmlFor={'yes'}
                >
                  {t('facilityModal.options.yes')}
                </label>
              </div>
            </div>
            {(userInfo?.is_global ||
              userInfo?.is_admin ||
              userInfo?.is_corporate) && (
              <>
                <span className='customInput' style={{marginBottom: 8}}>
                  {t('facilityModal.dateLabels.lastWeeklyDate')}
                </span>
                <Datepicker
                  setValue={e => {
                    if (e) {
                      setData(old => ({
                        ...old,
                        last_weekly_date: moment(e).format('MM/DD/YYYY'),
                      }));
                    } else {
                      setData(old => ({
                        ...old,
                        last_weekly_date: null,
                      }));
                    }
                  }}
                />
                <div style={{marginTop: 16}}>
                  <span className='customInput' style={{marginBottom: 8}}>
                    {t('facilityModal.dateLabels.lastMonthlyDate')}
                  </span>
                  <Datepicker
                    setValue={e => {
                      if (e) {
                        setData(old => ({
                          ...old,
                          last_monthly_date: moment(e).format('MM/DD/YYYY'),
                        }))
                      } else {
                        setData(old => ({
                          ...old,
                          last_monthly_date: null,
                        }));
                      }
                    }}
                  />
                </div>
                <div style={{marginTop: 16}}>
                  <span className='customInput' style={{marginBottom: 8}}>
                    {t('facilityModal.dateLabels.lastQuarterlyDate')}
                  </span>
                  <Datepicker
                    setValue={e => {
                      if (e) {
                        setData(old => ({
                        ...old,
                        last_quarterly_date: moment(e).format('MM/DD/YYYY'),
                        }));
                      } else {
                        setData(old => ({
                          ...old,
                          last_quarterly_date: null,
                        }));
                      }
                    }}
                  />
                </div>
                <div style={{marginTop: 16}}>
                  <span className='customInput' style={{marginBottom: 8}}>
                    {t('facilityModal.dateLabels.lastSemiAnnualDate')}
                  </span>
                  <Datepicker
                    setValue={e => {
                      if (e) { 
                        setData(old => ({
                        ...old,
                        last_semiannual_date: moment(e).format('MM/DD/YYYY'),
                        }));
                      } else {
                        setData(old => ({
                          ...old,
                          last_semiannual_date: null,
                        }));
                      }
                    }}
                  />
                </div>
                <div style={{marginTop: 16}}>
                  <span className='customInput' style={{marginBottom: 8}}>
                    {t('facilityModal.dateLabels.lastAnnualDate')}
                  </span>
                  <Datepicker
                    setValue={e => {
                      if (e) {
                        setData(old => ({
                        ...old,
                        last_annual_date: moment(e).format('MM/DD/YYYY'),
                        }));
                      } else {
                        setData(old => ({
                          ...old,
                          last_annual_date: null,
                        }));
                      }
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <div className='facility-modal__btns'>
            <div
              onClick={() => {
                setModal(false);
                setData(null);
              }}
              className='facility-modal__cancel'
            >
              {t('facilityModal.buttons.cancel')}
            </div>
            <div onClick={createFacility} className='facility-modal__create'>
              {t('facilityModal.buttons.create')}
            </div>
          </div>
        </form>
      </div>
      <div
        className='facility-modal__bg'
        // onClick={() => {
        //   setModal(false);
        //   setData(null);
        // }}
      ></div>
    </div>
  );
}
